import React, { Component } from 'react'
import './Project.css'

import Res from '../values/Resources'

import CustomLink from '../components/CustomLink'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'

export default class Project extends Component {

	constructor(props) {
		super(props)

		this.state = {
			project: Res.projects.find(project => project.id === props.match.params.id),
			show: [false, false, false, false]
		}
	}

	componentDidMount() {
		console.log('project onMount')
		//window.scrollToTop()
		setTimeout(() => {
			let show = [true, false, false, false]
			this.setState({ show })
		}, 100)

		setTimeout(() => {
			let show = [true, true, false, false]
			this.setState({ show })
		}, 300)

		setTimeout(() => {
			let show = [true, true, true, false]
			this.setState({ show })
		}, 500)

		setTimeout(() => {
			let show = [true, true, true, true]
			this.setState({ show })
		}, 700)

	}

	componentDidUpdate(prevProps) {
	    if (this.props.location !== prevProps.location) {
	    	//window.scrollTo(0, 0)
	    }
	}

	handleOnClose = (e) => {
		console.log('onClose')
		e.preventDefault()
		this.props.history.goBack()
	}

	renderLinks = (project) => {
		if(!project.links)
			return null

		return (
			<div className='links'>
				{project.links && project.links.map(link => {
					let title

					switch(link.type) {
						case 'web':
							title = Res.strings.project_links_web
							break
						case 'ios':
							title = Res.strings.project_links_ios
							break
						case 'android':
							title = Res.strings.project_links_android
							break
					}

					return <a key={link.type} className='link' href={link.url} target='_blank'>{title}</a>
				})}
			</div>
		)
	}

	render() {

		let { project, show } = this.state

		let closeBtn = 'closeBtn', 
			name = show[0] ? 'visible' : '',
			type = show[1] ? 'visible' : '',
			title = show[1] ? 'visible' : '',
			subtitle = show[1] ? 'visible' : '',
			goal = show[2] ? 'visible' : '',
			goal_content = show[2] ? 'visible' : '',
			result = show[3] ? 'visible' : '',
			result_content = show[3] ? 'visible' : ''

		closeBtn += show[0] ? ' visible' : ''

		return (
			<div className='project'>
				<div className={closeBtn} onClick={this.handleOnClose}>
					<div className='inner'>
						<FontAwesomeIcon id='icon' icon='times'/>
					</div>
				</div>
				<div className='intro' style={{backgroundColor: project.backgroundColor}}>
					<h3 className={name}>{Res.strings.name}</h3>
					<h4 className={type} style={{color: project.accentColor}}>{project.type}</h4>
					<h1 className={title} >{project.name}.</h1>
					<h2 className={subtitle} >{project.description}.</h2>
					<div className='info'>
						<div className='details'>
							<h4 className={goal} style={{color: project.accentColor}}>{Res.strings.project_intro_goal}</h4>
							<p className={goal_content} >{project.goal}</p>
						</div>
						<div className='details'>
							<h4 className={result} style={{color: project.accentColor}}>{Res.strings.project_intro_result}</h4>
							<p className={result_content} >{project.result}</p>
						</div>
					</div>
					
					
				</div>
				{/*
				<div className='banner' style={{backgroundColor: project.bannerColor}}>
					<img src={require(`../assets/${project.img}`)} className={project.wideImg ? 'wideImg' : ''}/>
				</div>
				*/}
				<div className='content'>
					{project.features.map((feature, i) => (
						<div key={i} className={i % 2 == 0 ? 'left' : 'right'}>
							<div className='info'>
								<h1>{feature.title}.</h1>
								<p>{feature.description}</p>
							</div>
							<div className='banner' style={{backgroundColor: feature.color}}>
								<img src={require(`../assets/${feature.img}`)} className={feature.wideImg ? 'wideImg' : ''}/>
							</div>
						</div>
					))}
				</div>
				{this.renderLinks(project)}
				<div className='bottom'/>
				<div id='background'>
					<CustomLink
				  	  link={`mailto:${Res.strings.menu_contact_email}`}
				  	  title={Res.strings.bio_action}/>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/Project.js